import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Buttons/Button';
import IconWithText from '../Icons/IconWithText';

const CommentReplyButton = ({ onClick }) => (
  <Button onClick={onClick} classes="reply-btn grey-link h5" faux>
    <IconWithText name="reply" size="s" fill="grey">Reply</IconWithText>
  </Button>
);

CommentReplyButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CommentReplyButton;



// WEBPACK FOOTER //
// ./library/app/components/Global/Comments/CommentReplyButton.js